import React, { useContext } from "react";
import MuiCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormContext from "./FormContext";

interface CheckboxProps {
  name: string;
  label: string;
  disabled?: boolean;
}

const Checkbox = ({ name, label, disabled = false }: CheckboxProps) => {
  const context = useContext(FormContext);
  const { value } = context.get(name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    context.set(name, newValue);
  };

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          checked={!!value}
          onChange={handleChange}
          name={name}
          data-testid={name}
          color="primary"
          disabled={disabled}
        />
      }
      label={label}
    />
  );
};

export default Checkbox;
